import { render, staticRenderFns } from "./TaskSettingForm.vue?vue&type=template&id=06841001&"
import script from "./TaskSettingForm.vue?vue&type=script&lang=js&"
export * from "./TaskSettingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports